import React, { useContext, useState } from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

import { AuthContext } from "../services/Context/Auth/context";
import User from "../services/db/user";
import { useNavigate } from "react-router-dom";

const ChangePassword = () => {
  const navigate = useNavigate();
  const { handleLogout } = useContext(AuthContext);

  const { user } = useContext(AuthContext);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");

  const handleLn = async (e) => {
    e.preventDefault();
    try {
      await new User().changePassword(
        user.email, // or user.username if that's your key
        oldPassword,
        newPassword
      );
      handleLogout();
      navigate("/");
    } catch (err) {
      alert(err.message);
    }
  };
  return (
    <form onSubmit={handleLn}>
      <Grid container spacing={1} sx={{ height: "100%" }}>
        <Grid
          item
          xs={12}
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="100vh"
          sx={{ bgcolor: "#757575" }}
        >
          <Box
            display="flex"
            flexDirection="column"
            textAlign="center"
            alignItems="center"
            borderRadius={5}
            sx={{
              width: "600px",
              height: "600px",
              bgcolor: "#fafafa",
              py: "100px",
            }}
          >
            <Typography variant="h4">Change Password</Typography>

            <TextField
              variant="outlined"
              placeholder="Old Password"
              type="password"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              InputProps={{ sx: { borderRadius: "50px" } }}
              sx={{ width: "450px", py: 2 }}
            />

            <TextField
              variant="outlined"
              placeholder="New Password"
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              InputProps={{ sx: { borderRadius: "50px" } }}
              sx={{ width: "450px", py: 2 }}
            />

            <Button
              variant="contained"
              sx={{
                width: "450px",
                py: 2,
                backgroundColor: "#e91e63",
                borderRadius: "50px",
              }}
              type="submit"
            >
              Submit
            </Button>
          </Box>
        </Grid>
      </Grid>
    </form>
  );
};

export default ChangePassword;
